import React, { useEffect, useState } from "react";
import Conf from "./Conf";
import ReceptTable from "./components/ReceptTable";
import { getPermission } from "./js/main";

const cookie = JSON.parse(localStorage.getItem(Conf.cookieName));
export default function PrintDelivery() {
  const [profile, setProfile] = useState();
  const [report, setReport] = useState();

  useEffect(() => {
    async function getAuth() {
      if (cookie && cookie.token) {
        var auth = await getPermission(cookie.token);
        if (auth.profile && auth.profile.usn) {
          setProfile(auth.profile);
          if (cookie.print) {
            setReport(cookie.print);
          }
        }
      }
    }
    if (!profile) getAuth();
  }, [profile]);

  useEffect(() => {
    if (report) {
      setTimeout(() => {
        window.print();
      }, 2000);
    }
  }, [report]);
  return (
    <div style={{ padding: "0px", margin: "0px" }}>
      {report && (
        <>
          <h2 style={{ marginTop: "0px" }}>{report.subTitle}</h2>
          <ReceptTable report={report} />
        </>
      )}
    </div>
  );
}
